import { format } from "date-fns";
import { pascalCase } from "pascal-case";
import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { surveySelector } from "../../../redux/surveySlice";
import InspectionList from "../../home/InspectionList";
import SurveyLinks from "./SurveyLinks";
const Description = () => {
  const survey = useSelector(surveySelector);
  let nSurvey = { ...survey };

  return (
    <>
      <div className="contentMain pe-0 overflow-hidden">
        <Row>
          <Col lg="9">
            <div className="topbar">
              <Row className="align-items-center">
                <Col lg="6">
                  <h2 className="heading1">{nSurvey.hdcAssetReference}</h2>
                </Col>
                <Col lg="6">
                  {" "}
                  <SurveyLinks />
                </Col>
              </Row>
            </div>
            <Card className="cardDetail">
              <div className="card-body">
                <div className="cardTopHeader">
                  <Row>
                    <Col lg="10">
                      <Row>
                        <Col lg="3">
                          <div className="infoCard">
                            <h3>Reference</h3>
                            <p>{nSurvey.wheRef}</p>
                          </div>
                        </Col>
                        <Col lg="3">
                          <div className="infoCard">
                            <h3>Template</h3>
                            <p>{nSurvey.templateName}</p>
                          </div>
                        </Col>
                        <Col lg="3">
                          <div className="infoCard">
                            <h3>Author</h3>
                            <p>{nSurvey.adminName}</p>
                          </div>
                        </Col>
                        <Col lg="3">
                          <div className="infoCard">
                            <h3>Assigned to (Surveyor)</h3>
                            <p>{nSurvey.surveyorName}</p>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg="2">
                      <div className="status drafts infoCard">
                        <h3>Status</h3>
                        <p>{nSurvey.status && pascalCase(nSurvey.status)}</p>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Row>
                  <Col lg="4">
                    <div className="infoCard">
                      <h3>Inspection date</h3>
                      <p>
                        {nSurvey.inspectionDate &&
                          format(
                            new Date(nSurvey.inspectionDate),
                            "MMM dd, yyyy"
                          )}
                      </p>
                    </div>
                  </Col>

                  <Col lg="4">
                    <div className="infoCard">
                      <h3>Client ref</h3>
                      <p>{nSurvey.clientRef}</p>
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="infoCard">
                      <h3>Plan</h3>
                      <p>{nSurvey.plan ? "Yes" : "No"}</p>
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="infoCard">
                      <h3>Tenure</h3>
                      <p>{nSurvey.tenure}</p>
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="infoCard">
                      <h3>Internal Inspection</h3>
                      <p>{nSurvey.internalInspection ? "Yes" : "No"}</p>
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="infoCard">
                      <h3>Locality</h3>
                      <p>{nSurvey.locality}</p>
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="infoCard">
                      <h3>Developed Site Area</h3>
                      <p>{nSurvey?.developedArea}</p>
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="infoCard">
                      <h3>Undeveloped Site Area</h3>
                      <p>{nSurvey?.undevelopedArea}</p>
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="infoCard">
                      <h3>No. of parking spaces/pit...</h3>
                      <p>{nSurvey.noOfSpacesPitchesBedSpaces}</p>
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="infoCard">
                      <h3>Current Use</h3>
                      <p>{nSurvey.currentUse}</p>
                    </div>
                  </Col>
                  <Col lg="12">
                    <div className="infoCard">
                      <h3>Description</h3>
                      <p>{nSurvey.description}</p>
                    </div>
                  </Col>
                </Row>
              </div>
            </Card>
          </Col>

          <Col lg="3">
            <div className="rightMain">
              <Card className="card-inspection">
                <div className="card-title">
                  <h3 className="heading1">Inspections</h3>
                </div>
                <div className="card-body py-0">
                  {/* <SurveyInspection /> */}
                  {/*  <NoInspection/> */}
                  <InspectionList />
                </div>
              </Card>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Description;
